
import {  GET_APPELLATE,  SET_APPELLATE_DATA } from "types/actions/appellateMaster.action";
import { AppActions } from "../../types";
import { AppellateMasterData } from "types/models/appellateMaster/AppellateMasterApp";
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentAppellate: AppellateMasterData | null;
  appellate: AppellateMasterData[];
  appellateCount: number;
 
} = {
  currentAppellate: null,
  appellate: [],
  appellateCount: 0,
  
};

const AppellateMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_APPELLATE:
      return {
        ...state,
        appellate: action.payload.data,
        appellateCount: action.payload.total,
      };
    case SET_APPELLATE_DATA:
      return {
        ...state,
        currentAppellate: action.payload,
      };
    default:
      return state; 
  }
};

export default AppellateMaster;
